import React, { useEffect, useState } from 'react';
import { FaChevronCircleLeft } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import IframePlayer from 'src/components/IframePlayer';
import { urlWebsite } from 'src/config';
import { useLanguage } from 'src/hooks/Language';
import { useModal } from 'src/hooks/Modal';

import { Container, Sponsor, Apoio, SponsorGrid, ApoioGrid, ApoioImg, CourseItem } from './styles';

/* composition
[]
Category : 
{ 
title,
image,
type: 
width: 
height: 
border-radius:


}
  lessons : {
    image: 
    url:
    keywords:
    title: 
    description

  }



*/

interface ISponsor {
  url: string;
  link_url?: string;
  computer?: string;
  mobile?: string;

}
interface IParamsURL {
  projectHash?: string;
  eventHash?: string;
}
interface ISponsors {
  title: string;
  title_font_color: string;
  title_font_size: string;
  position: number;
  sponsors: Array<ISponsor>;
  size?: string;
  status?: string;
}

interface IProps {
  data: Record<string, any>[];
}

const LibraryWidgets: React.FC<IProps> = ({ data }) => {
  const { language } = useLanguage();
  const { addModal } = useModal();

  const [course, setCourse] = useState('');
  const [lesson, setLesson] = useState('');

  const courseItem = data && course ? data?.find(i => i?.hash === course) : {};
  const lessonItem = data && lesson && courseItem?.lessons?.length > 0 ? courseItem?.lessons?.find(i => i?.hash === lesson) : {};


  return (
    <>



      <div className='row flex-wrap gap-sm max-1200' style={{ background: 'none' }}>
        {!course && !lesson ? <>{data?.map(course => {


          return <CourseItem onClick={() => course?.type === 'image' ? false : setCourse(course?.hash)} >
            <img src={`${urlWebsite}/${course?.image}`} />
            {course?.subtitle ? <nav dangerouslySetInnerHTML={{ __html: course?.subtitle }} /> : <></>}

          </CourseItem>



        })}</> : <></>}
      </div>
      {course && !lesson ? <>
        <div className='column max-1200' style={{ gap: '30px', display: 'flex', flexDirection: 'column' }}>
          <div className='row-start gap-sm' style={{ background: 'none' }}><FaChevronCircleLeft onClick={() => { setCourse(''); setLesson('') }} style={{ cursor: 'pointer', width: '26px', color: '#fff', fontSize: '22px' }} /><p>{courseItem?.title}</p></div>
          <div className='row flex-wrap gap-sm max-1200' style={{ background: 'none' }}>

            {courseItem?.lessons?.map(item => {
              console.log(item)
              return <CourseItem onClick={() => setLesson(item?.hash)} >
                <img src={`${urlWebsite}/${item?.image}`} />
                {item?.title ? <p style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: item?.title }} /> : <></>
                }

              </CourseItem>


            })}
          </div>
        </div>
      </> : <></>
      }

      {
        course && lesson ? <>


          <div className='column max-1200 gap' style={{ gap: '30px', display: 'flex', flexDirection: 'column' }}>
            <div className='row-start gap-sm' style={{ background: 'none' }}><FaChevronCircleLeft onClick={() => setLesson('')} style={{ cursor: 'pointer', width: '26px', color: '#fff', fontSize: '22px' }} /><p>{lessonItem?.title}</p></div>
            <IframePlayer id={lessonItem?.video_id} />
            {lessonItem?.description ? <nav dangerouslySetInnerHTML={{ __html: lessonItem?.description }} /> : <></>}



          </div>

        </> : <></>
      }



    </>
  );
};

export default LibraryWidgets;
